import { AfterViewInit, Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
  Validators,
} from "@angular/forms";

@Component({
  selector: 'datepicker-input',
  template: `
    <input type="text" #datePickerInput data-toggle="datepicker" [placeholder]="placeholder" [formControl]="control" (input)="onInput($event)" (blur)="onBlur()"  />
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatepickerInputComponent),
      multi: true
    }
  ]
})
export class DatepickerInputComponent implements ControlValueAccessor, AfterViewInit {
  @ViewChild('datePickerInput') datePickerInput: ElementRef;

  @Input() placeholder = 'dd/mm/yyyy';
  @Input() required: boolean;

  control: UntypedFormControl = new UntypedFormControl('', this.validate.bind(this));

  onBlur() {
    setTimeout(() => {
      this.onChange(this.datePickerInput.nativeElement.value);
    }, 500)
  }

  ngAfterViewInit(): void {
    if (this.required) {
      this.control.setValidators([this.validate.bind(this), Validators.required]);
    } else {
      this.control.setValidators(this.validate.bind(this));
    }
  }

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  validate(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) {
      return null;
    }

    const value = control.value;
    const [day, month, year] = value.split('/');

    const date = new Date(`${year}-${month}-${day}`);
    const isValidDate = date.getDate() === parseInt(day) && date.getMonth() === parseInt(month) - 1 && date.getFullYear() === parseInt(year);

    return isValidDate ? null : { invalidDate: true };
  }

  writeValue(value: string): void {
    this.control.setValue(value);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onInput(event: any): void {
    this.onChange(event.target.value);
  }

}
